import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Select from '@material-ui/core/Select';
import PropTypes from 'prop-types';


const DecimalsSelect = props => (
  <FormControl fullWidth>
    <FormLabel htmlFor="decimals">Stellen</FormLabel>
    <Select
      native
      value={props.value}
      onChange={props.onChange}
      inputProps={{
        id: 'decimals',
      }}
    >
      <option value="2">2</option>
      <option value="4">4</option>
      <option value="6">6</option>
      <option value="8">8</option>
    </Select>
  </FormControl>

);

export default DecimalsSelect;

DecimalsSelect.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/calculator/DecimalsSelect.js